<template>
    <div class="help-container">

        <el-popover placement="bottom"
                    width="850"
                    trigger="click"
                    >
            <template #reference>
                <div id="shortcut-button">

                    <el-tooltip :content="tooltip"
                                placement="bottom">
                        <div class="help">
                            <span class="material-symbols-outlined">
                                info
                            </span>
                            <div class="text">{{helpText}}</div>
                        </div>

                    </el-tooltip>
                </div>
            </template>
            
            <div>
                <el-tabs v-model="activeTab">

                    <el-tab-pane :label="$t('helpInfo.quickStartNotes')"
                                 name="quickStart">
                        <QuickStartNotes />
                    </el-tab-pane>

                    <el-tab-pane :label="$t('helpInfo.keybordShortcuts')"
                                 name="shortcuts">
                        <el-table :data="tableData" style="width: 100%">
                            <el-table-column prop="win"
                                             label="Win"
                                             width="180" />
                            <el-table-column prop="mac"
                                             label="Mac"
                                             width="180" />
                            <el-table-column :label="$t('helpInfo.action')">
                                <template #default="scope">
                                    {{$t(scope.row.actionKey)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane :label="$t('helpInfo.tours')"
                                 name="tours">
                        <UserTour />
                    </el-tab-pane>

                </el-tabs>

            </div>

        </el-popover>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { shortcuts } from '@/utils/shortcuts';
    import QuickStartNotes from './QuickStartNotes.vue'
    import UserTour from '@/features/UserTour/UserTour.vue'

    export default defineComponent({
        components: {
            UserTour,
            QuickStartNotes,
        },
        data() {
            return {
                tableData: [] as any,
                activeTab: 'quickStart',
                tooltip: this.$t('helpInfo.helpInformation'),
                helpText: this.$t('helpInfo.help'),
            }
        },
        created() {
            this.tableData = [
                shortcuts.moveNext,
                shortcuts.moveUp,
                shortcuts.saveMoveNext,
                shortcuts.saveMoveUp,
                shortcuts.goToNextPage,
                shortcuts.goToPreviousPage,
                shortcuts.copy,
                shortcuts.translate,
                shortcuts.addTranslation,
                shortcuts.updateTranslation,
                shortcuts.discardTranslation,
                shortcuts.clearStyles,
                shortcuts.variantsPopover,
                shortcuts.nextTranslateSegment,
                shortcuts.merge,
                shortcuts.split,
                shortcuts.addSegmentToMerge,
                shortcuts.removeSegmentToMerge,
                shortcuts.saveMerge,
                shortcuts.discardMerge,
            ]
        }
    })

</script>

<style lang="scss" scoped>

    .help-container{
        margin-left: 20px;
    }

    .help {
        display: flex;
        align-items: center;
        cursor: pointer;

        .text {
            margin-left: 5px;
        }
    }

</style>